import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, SimpleChanges, OnChanges, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ImageModel } from '@core/models/product/image.model';
import { AddItemToCartCommand, AddItemToWishlistCommand, RemoveItemFromWishlistCommand, SkuResult, UploadProductImagesCommand, WishlistItemModel, WishlistModel } from '@core/services/api.service';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { CartState } from '@ngxs-store/cart/cart.state';
import { RemoveItemFromWishListAction } from '@ngxs-store/wish-list-store/wish-list.actions';
import { WishListState } from '@ngxs-store/wish-list-store/wish-list.state';
import { Store } from '@ngxs/store';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { DecodedToken } from '@core/models';
import { AssignImageModel } from '@core/models/product/assign.model';
import { UpdateDescriptionModel } from '@core/models/product/update.model';

@Component({
    selector: 'app-product-detail',
    templateUrl: './product-detail.component.html',
    styleUrls: ['./product-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDetailComponent implements OnChanges {
    @Input() isLoading: boolean;
    @Input() product: SkuResult;
    @Input() wishlist: WishlistModel;
    @Input() decodedToken: DecodedToken;
    @Output() productLoaded = new EventEmitter<SkuResult>();
    @Output() addToCart = new EventEmitter<AddItemToCartCommand>();
    @Output() addToWishlist = new EventEmitter<WishlistItemModel>();
    @Output() uploadFiles = new EventEmitter<ImageModel[]>();
    @Output() assignCover = new EventEmitter<AssignImageModel>();
    @Output() updatedDescription = new EventEmitter<UpdateDescriptionModel>();

    userQuantity = 1;
    hasValidToken = false;
    productImages = [];
    selectedImage: string | ArrayBuffer | null = null;
    noImageRole = false;
    temp_images: any[] = [];
    uploadStatus: string = "";
    productBase64 = [];
    productSRC = [];
    noImageLink: string = "https://sgresources.supergrp.net/SGConvenience/Wholesale/Brand/NoImage.png";
    isEditing = false;
    editingDescription: string = '';
    currentDescription: string = '';

    constructor(public store: Store, private toaster: ToastrService, private http: HttpClient, private cdr: ChangeDetectorRef) {
        this.hasValidToken = this.store.selectSnapshot(AuthState.getHasValidToken);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.product && !changes.product.firstChange) {
            this.productLoaded.emit(this.product)
            this.productImages = this.product.imageUrl.split(';');
            this.selectedImage = this.productImages[0];
            if(this.productImages[0] != "")
                this.buildObjects();
        }

        if(changes.decodedToken){
            this.noImageRole = changes.decodedToken.currentValue.roles.includes("NoImage");
        }
    }

    buildObjects() {
        this.productImages.forEach((image, index) => {
            this.productBase64.push(image);
        });
    }

    onWishlist() {
        return this.wishlist?.wishlistItems?.some(x => x.productId == this.product.skuCode);
    }

    addProductItemToCart(product: SkuResult, quantity) {
        if ((this.getProductQty(product.skuCode, this.store.selectSnapshot(CartState.Cart).cartItems) + quantity) <= 999) {
            if (product.listPriceIncl > 0) {
                this.addToCart.emit(
                    new AddItemToCartCommand({
                        skuCode: product.skuCode,
                        quantity: quantity,
                        dealReference: product.dealReference
                    })
                );
            } else {

                //   this.toaster.success("Please login, before you add to cart :) ", "Login", { timeOut: 5000 });
                // this.router.navigate(['/login']);
            }
        } else {
            this.toaster.error("Please ensure quantity is less than 1000 ", "Quantity Limit", { timeOut: 5000 });
        }
    }

    addItemToWishlist(product: SkuResult, quantity) {
        if ((this.getProductQty(product.skuCode, this.store.selectSnapshot(WishListState.getItems).wishlistItems) + quantity) <= 999) {
            if (product.listPriceIncl > 0) {
                this.addToWishlist.emit(new AddItemToWishlistCommand({
                    skuCode: product.skuCode,
                    quantity: quantity,
                    dealReference: product.dealReference
                })
                );
            } else {

                // this.toaster.success("Please login, before you add to wishlist :) ", "Login", { timeOut: 5000 });
                // this.router.navigate(['/login']);
            }
        } else {
            this.toaster.error("Please ensure quantity is less than 1000 ", "Quantity Limit", { timeOut: 5000 });
        }
    }

    getProductQty(productId, items) {
        let index = items.findIndex(product => product.productId === productId);
        if (index != -1) {
            return items[index]?.quantity;
        } else {
            return 0;
        }
    }

    removeFromWishList(product) {
        this.store.dispatch(new RemoveItemFromWishListAction({
            command: new RemoveItemFromWishlistCommand({
                skuCode: product.skuCode
            })
        }));
    }

    onFileSelected(event: Event): void {
        this.temp_images = [];
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
          const file = input.files[0];
          if(file){
            if(file.type !== 'image/png')
            {
                this.uploadStatus = "Only PNG files are allowed.";
            }else if (file.size > 1048576) {
                this.uploadStatus = "File size must be less than 1 MB.";
            }else{
                const reader = new FileReader();
                reader.onload = (e) => {
                    const base64String = reader.result as string;
                    const base64Data = base64String.split(',')[1];
                    this.temp_images[0] = ({ src: reader.result, base64: base64Data });
                    this.updateSelectedImageSrc();
                    this.cdr.markForCheck();
                };
                reader.readAsDataURL(file);
                this.uploadStatus = "Image Uploaded Successfully";
            }
          }
        }
    }

    updateSelectedImageSrc(): void {
        if(!this.temp_images[0]?.src) return;

        if(this.productImages[0] == this.noImageLink){
            this.productImages[0] = this.temp_images[0].src;
            this.productBase64[0] = this.temp_images[0].base64;
            this.productSRC[0] = this.temp_images[0].src;
        }else{
            this.productImages.push(this.temp_images[0].src);
            this.productBase64.push(this.temp_images[0].base64);
            this.productSRC.push(this.temp_images[0].src);
        }

        this.selectedImage = this.temp_images[0].src;
        this.uploadStatus = "";
        this.saveImagesToFolder();
    }

    clear() {
        this.productImages = this.product.imageUrl.split(';');
        this.temp_images = [];
        this.selectedImage = this.productImages[0];
    }

    saveImagesToFolder() {
        let imagesModel: ImageModel[] = [];
        let imageModel: ImageModel = {};

        this.productImages.forEach((image, index) => {
            imageModel = {};
            imageModel.src = this.productBase64[index];
            imageModel.skuCode = this.product.skuCode;
            imagesModel.push(imageModel);
        });

        this.uploadFiles.emit(imagesModel);
    }

    setCoverImage(data){
        let assignImageModel: AssignImageModel = {};
        let srcs: string[] = [];

        this.productImages.forEach((image, index) => {
            srcs.push(this.productBase64[index]);
        });

        assignImageModel.mainImageIndex = this.productImages.findIndex(i => i == data);
        assignImageModel.skuCode = this.product.skuCode;
        assignImageModel.src = srcs;

        this.assignCover.emit(assignImageModel);
    }

    editDescription(currentText: string) {
        this.currentDescription = currentText;
        this.isEditing = true;
        this.editingDescription = this.currentDescription || '';
    }

    saveDescription() {
        let updateDescriptionModel: UpdateDescriptionModel = {};
        updateDescriptionModel.skuCode = this.product.skuCode;
        updateDescriptionModel.updatedDescription = this.editingDescription;

        this.updatedDescription.emit(updateDescriptionModel);
        this.isEditing = false;
    }

    undoDescription() {
        this.editingDescription = this.currentDescription || '';
        this.isEditing = false;
    }

}


